import { DateTime } from 'luxon';
import { map, Observable } from 'rxjs';

import { PolicySummary } from '@amfam/policy/models/lib/models/policy-summary';
import { SourceSystem } from '@amfam/policy/models/lib/models/source-system-type';

export function removeDuplicateAndExpiredPolicies() {
  return (policies$: Observable<PolicySummary[]>) =>
    policies$.pipe(
      map(policies => {
        const uniquePolicies = new Map();
        // DRE-39776 In the scenario of classic to rome migration the policy number is same for both,
        // when classic policy is canceled and rome policy is scheduled it would get dropped in the dupe check if we send expired policies to dupe check
        const activeOrScheduledPolicies = policies.filter(
          policy => policy.status === 'Inforce' || policy.status === 'Scheduled'
        );
        activeOrScheduledPolicies.forEach(policy => {
          const policyNumber = policy.policyNumber;
          const dupePolicy = getDuplicatePolicy(policy, policies);
          if (!uniquePolicies.has(policyNumber)) {
            if (dupePolicy) {
              const validPolicy = getValidPolicy(policy, dupePolicy);
              if (validPolicy) uniquePolicies.set(policyNumber, validPolicy);
            } else {
              uniquePolicies.set(policyNumber, policy);
            }
          }
        });
        return Array.from(uniquePolicies.values());
      })
    );
}

function getValidPolicy(policy: PolicySummary, dupePolicy: PolicySummary) {
  return [policy, dupePolicy].find(p => {
    const dupePolicyInForceOnDate = DateTime.fromISO(p.effectiveDate, { zone: 'utc' }).toFormat(
      'yyyy-MM-dd'
    );
    const dupePolicyExpiresOnDate = DateTime.fromISO(p.endEffectiveDate, {
      zone: 'utc'
    }).toFormat('yyyy-MM-dd');
    const todayDate = DateTime.now().toFormat('yyyy-MM-dd');
    // TODO will update condition when horison exp date fix comes
    if (
      (dupePolicyInForceOnDate <= todayDate &&
        dupePolicyExpiresOnDate > todayDate &&
        p.status !== 'Other') ||
      (p.sourcePath === SourceSystem.HORISON && Number.isFinite(p.generalizedProductType))
    ) {
      return p;
    }
  });
}

function getDuplicatePolicy(policy: PolicySummary, policies: PolicySummary[]) {
  const duplicatePolicies = policies.filter(p => p.policyNumber === policy.policyNumber);
  if (duplicatePolicies.length > 1)
    return duplicatePolicies.find(
      dp =>
        dp.sourcePath !== policy.sourcePath ||
        !DateTime.fromISO(dp.effectiveDate, { zone: 'utc' }).hasSame(
          DateTime.fromISO(policy.effectiveDate, { zone: 'utc' }),
          'day'
        ) ||
        !DateTime.fromISO(dp.endEffectiveDate, { zone: 'utc' }).hasSame(
          DateTime.fromISO(policy.endEffectiveDate, { zone: 'utc' }),
          'day'
        )
    );
}
